const update = function(width, height) {
  Sizes.height = height;
  Sizes.width = width;
  Sizes.navHeight =
    document.getElementById("nav") &&
    document.getElementById("nav").scrollHeight;
  const employeeListSearchControlsHeight =
    document.getElementById("EmployeeListSearchControls") &&
    document.getElementById("EmployeeListSearchControls").scrollHeight;
  Sizes.mainHeight = height - Sizes.navHeight;
  const chartBboxTop = document.getElementById("chartContainer")
    ? document.getElementById("chartContainer").getBoundingClientRect().top
    : 0;
  Sizes.chartHeight = Sizes.height - chartBboxTop;
  Sizes.employeeListHeight =
    Sizes.mainHeight - employeeListSearchControlsHeight;
  Sizes.mainWidth = width * 0.9;
  Sizes.sidebarWidth = width * 0.1;
  Sizes.scale = width / 1920;
};

var Sizes = {
  height: 0,
  width: 0,
  navHeight: 0,
  mainHeight: 0,
  chartHeight: 0,
  mainWidth: 0,
  sidebarWidth: 0,
  scale: 1,
  _update: update,
  forceUpdate: function() {
    this._update(document.body.clientWidth, document.body.clientHeight);
  }
};

Sizes.forceUpdate();

module.exports = Sizes;
